// extracted by mini-css-extract-plugin
export default {"heading":"TgRFa1g2do4FUykFhVYh"};